import React, { useState, useMemo, useEffect } from "react";
import { Row, Col, Container, Card, CardBody, Button } from "reactstrap";
import { useNavigate, useParams } from "react-router-dom";
import TextInput from "../../../custom/components/Text-Input/TextInput.js";
import CheckboxInput from "../../../custom/components/CheckBox-Input/CheckboxInput.js";
import CustomForm from "../../../custom/Forms/CustomForm.js";
import { getRecords, saveRecords } from "../../../services/api.service.js";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import useCreateForm from "../../../custom/Utils/UseCreateFormUtils.js";
import { createPageData } from "./MenuFile.js";
import { basicFormData } from "./MenuFile.js";
import { validate } from "../../../custom/validations/Validate.js";
import {
  formContentContainer,
  loaderOverlay,
} from "../../../Style/loaderOverly.js";
import { AvForm } from "availity-reactstrap-validation";
import { LoaderCreatePage } from "../../Loader/Loader.js";
const MenuView = () => {
  const breadcrumbItems = [];
  const { id } = useParams();
  const navigate = useNavigate();

  const { payload, navigatePage, headerName, getEndpoint } = createPageData();

  const initialPayload = useMemo(() => payload, []);
  const [loadingData, setLoadingData] = useState(id ? true : false);
  const [formData, setFormData] = useState(basicFormData());
  const [customerSelect, setCustomerSelect] = useState("");
  const [fetchedData, setFetchedData] = useState(null);
  const [isCustomerModelOpen, setIsCustomerModelOpen] = useState(false);
  const [parentData, setParentData] = useState();

  useEffect(() => {
    if (id) {
      getEditData(id);
    }
  }, [id]);

  useEffect(() => {
    if (fetchedData) {
      let data = fetchedData;
      setFormData((prevState) => ({
        ...prevState,
        inputData: {
          ...prevState.inputData,
          ...data,
        },
      }));
    }
  }, [fetchedData]);
  useEffect(() => {
    if (formData.inputData) {
      getParentData();
    }
  }, [formData.inputData]);

  const getEditData = async (id) => {
    console.log("initialPayload", initialPayload);

    try {
      let payload = {
        modelName: initialPayload?.modelName,
      };
      if (id) {
        payload.whereCondition = { id: id };
      }
      const responseData = await getRecords(payload, getEndpoint);

      if (responseData?.data && responseData.data.length > 0) {
        const data = responseData.data[0];
        setFetchedData(data);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoadingData(false);
    }
  };
  const getParentData = async () => {
    console.log("initialPayload", initialPayload);

    try {
      let payload = {
        modelName: "menu_masters",
        whereCondition: { is_child: false },
      };

      const responseData = await getRecords(payload, "/listMenu");

      if (responseData?.data && responseData.data.length > 0) {
        const data = responseData.data;

        let parent = data?.find((item) => {
          console.log("item", item.id, formData?.inputData?.parent_id);
          return item.id == formData?.inputData?.parent_id;
        });

        console.log("data", parent, data);

        setParentData(parent?.menu_name);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoadingData(false);
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Row>
            <Col xl="12">
              <Card>
                <CardBody>
                  <div style={formContentContainer}>
                    <AvForm className="needs-validation">
                      <div className="card mt-4">
                        <div className="card-header">
                          <h5>Menu Details</h5>
                          <Button
                            color="secondary"
                            className="waves-effect waves-light me-1 back-button"
                            onClick={() => navigate(navigatePage?.back)}
                          >
                            Back
                          </Button>
                        </div>
                        <div className="card-body">
                          <Row>
                            {/* First Section (Left Side) */}
                            <Col
                              md="6"
                              className="border-end border-secondary p-3"
                            >
                              <p>
                                <strong>Menu Name: </strong>
                                {formData?.inputData?.menu_name || "-"}
                              </p>
                              <p>
                                <strong>Menu Icon: </strong>
                                {formData?.inputData?.menu_icon || "-"}
                              </p>
                              <p>
                                <strong>Menu Url: </strong>
                                {formData?.inputData?.menu_url || "-"}
                              </p>
                              <p>
                                <strong>Sequence: </strong>
                                {formData?.inputData?.sequence || "-"}
                              </p>
                            </Col>

                            {/* Second Section (Right Side) */}
                            <Col md="6" className="p-3">
                              <p>
                                <strong>Status: </strong>
                                {formData?.inputData?.is_active == true
                                  ? "ACTIVE"
                                  : "IN-ACTIVE" || "-"}
                              </p>
                              <p>
                                <strong>Is Visible On Mobile: </strong>
                                {formData?.inputData?.is_visible_on_mobile ==
                                true
                                  ? "YES"
                                  : "NO" || "-"}
                              </p>
                              <p>
                                <strong>Is Child: </strong>
                                {formData?.inputData?.is_child == false
                                  ? "NO"
                                  : "YES" || "-"}
                              </p>
                              {console.log("parentData", parentData)}
                              {formData?.inputData?.is_child == true && (
                                <p>
                                  <strong>Parent: </strong>
                                  {parentData}
                                </p>
                              )}
                            </Col>
                          </Row>
                        </div>
                      </div>
                    </AvForm>

                    {/* Loader Overlay */}
                    {loadingData && (
                      <div style={loaderOverlay}>
                        <LoaderCreatePage />
                      </div>
                    )}
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default MenuView;
